import App from 'app/app.js';

function GradeService(ContentStore, ContentChangeAction) {
  var grades = R.pluck('name')(ContentStore.getEnum('Grade').values);

  this.getGrades = function () {
    return grades;
  };

  this.getNoGrade = function () {
    return 'GNA';
  };

  this.resolveGrade = function (grade) {
    if (!grade) {
      return null;
    }

    var gradeMatch = R.find(function (gradeKey) {
      return gradeKey.toUpperCase() === grade.toUpperCase();
    }, grades);

    if (gradeMatch) {
      return grade.toUpperCase();
    }

    var contentMatch = R.find(function (gradeKey) {
      var gradeContent = ContentStore.getContent(null, 'GRADE_' + gradeKey);
      return gradeContent.toUpperCase() === grade.toUpperCase();
    }, grades);

    return contentMatch || null;
  };

  ContentChangeAction.register(function () {
    grades = R.pluck('name')(ContentStore.getEnum('Grade').values);
  });
}

App.service('GradeService', ['ContentStore', 'ContentChangeAction', GradeService]);
